import React, { useEffect, useState, useContext } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { isEmpty } from '../../utils/helper'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import { getThumbnail } from '../../utils/helper'
import CustomMetadata from 'src/components/CustomMetadata/CustomMetadata'
import { AppContext } from 'src/views/context/app'
import Loading from 'react-fullscreen-loading'
import { GlobalContext } from 'src/views/context/GlobalState'
import { CustomDescriptionBox } from '../../../components'

const CreateVenueModal = (props) => {
  const { openModal, onCancel, data, addCallback, updateCallback, customMetadataMaster } = props
  const { loader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [thumbnail, setThumbnail] = useState('')
  const [address, setAddress] = useState('')
  const [geoLocation, setGeoLocation] = useState({
    latitude: 0,
    longitude: 0,
  })
  const [customMetadata, setCustomMetadata] = useState({})
  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState()

  const editFlag = !isEmpty(data)

  useEffect(() => {
    const venueImage = [
      {
        title: 'Banner *',
        id: 'venueBanner',
        width: 1200,
        height: 675,
        assetId: '',
        divheight: '9.56rem',
        divwidth: '17rem',
        setAssetId: (id) => {
          let temp = errorData
          temp[`thumbnail`] = ''
          setErrorData({ ...temp })
          setThumbnail(id)
        },
        setImage: () => {},
        onRemoveImg: () => {},
        imageUrl: '',
      },
    ]
    if (!isEmpty(data)) {
      handleEdit()
      venueImage[0]['assetId'] = data.thumbnail['_id']
      venueImage[0]['imageUrl'] = getThumbnail(
        userSessionObj.session_data.cf_domain_name,
        data.thumbnail['s3_key'],
      )
    }
    setImageData(venueImage)
  }, [])

  const handleEdit = () => {
    setName(data.name)
    setThumbnail(data.thumbnail['_id'])
    setDescription(data.description)
    setAddress(data.address)
    setGeoLocation({
      latitude: data.geoLocation.coordinates[0],
      longitude: data.geoLocation.coordinates[1],
    })
  }

  const handleChange = (event, func) => {
    const { value, name } = event.target
    let temp = errorData
    temp[`${name}`] = ''
    setErrorData({ ...temp })
    func(value)
  }
  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name Cannot be Empty!'
    }

    if (!thumbnail) {
      isFormValid = false
      temp.thumbnail = 'UploadContent Images!'
    }

    // if (address.trim().length === 0) {
    //   isFormValid = false
    //   temp.address = 'Select Artist!'
    // }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let payload = {}
    payload = {
      name: name,
      description: description,
      address: address,
      geoLocation: [Number(geoLocation.latitude), Number(geoLocation.longitude)],
      thumbnail: thumbnail,
      custom_metadata: customMetadata,
    }

    editFlag ? updateCallback(payload, data._id) : addCallback(payload)
  }

  return (
    <>
      <CModal size="lg" visible={openModal} alignment="center">
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="px-5 py-4">
          <CModalTitle>
            {!editFlag ? `Add` : `Edit`} {`Venue`}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow>
            <CCol>
              <CFormLabel>Name*</CFormLabel>
              <CFormInput
                type="text"
                value={name}
                name="name"
                onChange={(e) => handleChange(e, setName)}
              />
              <div className="message-text error-message">
                <p>{errorData.name}</p>
              </div>
            </CCol>
            <CCol>
              <CustomDescriptionBox
                title="Description"
                rows={1}
                value={description}
                onChange={setDescription}
              />
            </CCol>
          </CRow>
          <>
            <CRow>
              <CCol>
                <CustomDescriptionBox
                  title="Address"
                  rows={2}
                  value={address}
                  onChange={setAddress}
                />
              </CCol>
            </CRow>
            <CRow className="mt-3">
              <CCol>
                <CFormLabel>Latitude Cordinate</CFormLabel>
                <CFormInput
                  type="number"
                  value={geoLocation.latitude}
                  name="latitude"
                  min="-90"
                  max="90"
                  onChange={(e) => setGeoLocation({ ...geoLocation, latitude: e.target.value })}
                />
                <div className="message-text error-message">
                  <p>{errorData.latitude}</p>
                </div>
              </CCol>
              <CCol>
                <CFormLabel>Longitude Cordinate</CFormLabel>
                <CFormInput
                  type="number"
                  value={geoLocation.longitude}
                  name="longitude"
                  min="-180"
                  max="180"
                  onChange={(e) => setGeoLocation({ ...geoLocation, longitude: e.target.value })}
                />
                <div className="message-text error-message">
                  <p>{errorData.longitude}</p>
                </div>
              </CCol>
            </CRow>
          </>
          <CRow className="mt-4">
            <CustomMetadata
              isEdit={editFlag}
              editData={data}
              customMetadataMaster={customMetadataMaster}
              customPayload={customMetadata}
              setCustomPayload={setCustomMetadata}
            />
          </CRow>
          <CRow className="mt-5">
            {imageData && <ImageUploader data={imageData} />}
            <div className="message-text error-message">
              <p>{errorData.thumbnail}</p>
            </div>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleSave}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default CreateVenueModal
